import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import { useEffect, useState } from "react";
import { db } from "../firebase/client";
import type { Card } from "../types/cards.types";

export function useCards(broadcastId: string | null): Card[] {
	const [cards, setCards] = useState<Card[]>([]);

	useEffect(() => {
		if (!broadcastId) return;

		const q = query(
			collection(db, "broadcasts", broadcastId, "cards"),
			orderBy("date", "asc"),
		);

		const unsubscribe = onSnapshot(q, (snapshot) => {
			setCards(
				snapshot.docs.map((doc) => ({
					id: doc.id,
					...(doc.data() as Omit<Card, "id">),
				})),
			);
		});

		return unsubscribe;
	}, [broadcastId]);

	return cards;
}
